@if (lessonsWithParentAcc$ | async; as lessonsWithParent;) {
  @for (lessonWithParent of lessonsWithParent; track lessonWithParent; let index = $index) {
        <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{
                        lesson: lessonWithParent.lesson,
                        parent: lessonWithParent.parentLesson,
                        index: index
                    }"></ng-template>
  }
  @if (lessonsWithParent.length === 0 && !isLoading && hasMorePageToLoad() === false) {
    {{ 'activity_search.no_lessons_found' | translate }}
  }
}
@if (isLoading || ((lessonsWithParentAcc$ | async).length === 0 && hasMorePageToLoad())) {
  <mat-spinner></mat-spinner>
}
